import { useDispatch } from "react-redux";
import { ChevronLeftIcon } from "components/lib/Shared/Icons/sflIcons";
import { useState } from "react";

import CompanyOfficialsTab from "./CompanyOfficialsTab";

const StakeholderDetails = ({ handleGoBack, handleGoForward }) => {
  const dispatch = useDispatch();
  const [addNewOfficialSelected, setAddNewOfficialSelected] = useState(false);

  return (
    <div>
      <CompanyOfficialsTab
        setAddNewOfficialSelected={setAddNewOfficialSelected}
      />

      {!addNewOfficialSelected && (
        <div className="mt-4 px-4 py-3  sm:px-6">
          <div className="flex justify-between space-x-2">
            <div>
              {
                <button
                  type="button"
                  onClick={handleGoBack}
                  className="flex items-start float-right py-2 font-semibold rounded text-primary mt-7"
                >
                  <span className="flex items-center mr-4 h-7">
                    <ChevronLeftIcon
                      className="flex-shrink-0 w-5 h-5"
                      aria-hidden="true"
                    />
                  </span>
                  <p className="font-semibold">Go Back</p>
                </button>
              }
            </div>
            <button
              onClick={handleGoForward}
              className={`${"flex items-center px-4 py-2 mb-2 font-semibold text-white rounded bg-sflPrimary mt-7 disabled:cursor-not-allowed"}`}
            >
              Save and proceed
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default StakeholderDetails;
